import { uniqueId } from "lodash";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useMediaQuery } from "react-responsive";
import { isMobileQuery } from "../../../utils/helpers";


const MultiCarousel = ({
  responsiveSettings,
  data,
  carouselContainerClassname,
  listItemClassname
}) => {
  const isMobile = useMediaQuery(isMobileQuery)

  return <Carousel
    swipeable={isMobile}
    draggable={isMobile}
    showDots={true}
    centerMode
    responsive={responsiveSettings}
    ssr={true}
    infinite={true}
    autoPlaySpeed={5000}
    autoPlay={true}
    keyBoardControl={true}
    customTransition="all 1 linear"
    transitionDuration={500}
    containerClass={carouselContainerClassname ?? ''}
    removeArrowOnDeviceType={["tablet", "mobile"]}
    dotListClass="custom-dot-list-style"
    itemClass={listItemClassname ?? ''}
  >
    {
      data.map((item) => {
        return <div key={uniqueId()}
        >
          {item.node}
        </div>
      })
    }
  </Carousel>
}

export default MultiCarousel;